module.exports = __webpack_public_path__ + "static/img/5.9c9d16e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/5.png
// module id = aiTc
// module chunks = 0